import React from "react";
const icon = (
  <svg
    width="512"
    height="512"
    viewBox="0 0 512 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M256 32C194.1 32 144 82.1 144 144V192H80C71.2 192 64 199.2 64 208V448C64 456.8 71.2 464 80 464H432C440.8 464 448 456.8 448 448V208C448 199.2 440.8 192 432 192H368V144C368 82.1 317.9 32 256 32ZM256 96C291.3 96 320 124.7 320 160V192H192V160C192 124.7 220.7 96 256 96Z"
      fill="#8803E9"
    />
  </svg>
);

export default icon;
